/**
 * The level after a machine's last, announced: its card in the strip with the machine as a
 * silhouette and a question mark, its values still to come as shimmering bars, and a word that it
 * is in the works.
 */
import type { JSX } from 'react';

import type { UpgradeStat } from '@game/upgrade/upgrades';
import { t } from '@i18n/index';
import type { HexLook } from '@ui/art/hexArt';
import { HexPicture } from '@ui/components/HexPicture';
import { Icon } from '@ui/icons';

import { STAT_LABEL } from './levelText';

import './level.css';
import './soon.css';

export function SoonCard({
  level,
  stats,
  look,
}: {
  level: number;
  stats: readonly UpgradeStat[];
  look: HexLook;
}): JSX.Element {
  return (
    <article className="lcard soon" data-level={level} data-state="soon">
      <div className="mystery" aria-hidden="true">
        <HexPicture look={look} />
        <b>?</b>
      </div>
      <div className="lbody">
        <header>
          <span className="lv">
            <Icon id="star" />
            {t('info.level', { n: level })}
          </span>
          <span className="chip">{t('upgrade.soon')}</span>
        </header>
        <dl className="lstats">
          {stats.map((stat) => (
            <div key={stat}>
              <dt>{t(STAT_LABEL[stat])}</dt>
              <dd>
                <i className="ghost" />
              </dd>
            </div>
          ))}
        </dl>
      </div>
      <p className="after">{t('upgrade.soon-text')}</p>
    </article>
  );
}
